import queryString from 'query-string';

export const getPlaylistParamsFromUrl = () => {
  const urlParams = queryString.parse(window.location.search) || {};

  return {
    playlistItemId: cast(urlParams['playlist-item']),
    playlistId: cast(urlParams.playlist),
  };
};

const cast = (
  value: string | string[] | null | undefined,
): string | undefined =>
  typeof value === 'undefined' || value === null
    ? undefined
    : (value as string);
